export default __webpack_public_path__ + "static/plane-15231b52090cf97bd1a077a9b396a833.jpg";